/* eslint-disable space-before-blocks */
/* eslint-disable comma-spacing */
/* eslint-disable no-tabs */
/* eslint-disable import/no-named-as-default-member */
/* eslint-disable import/no-named-as-default */
import BaseRequest from './BaseRequest';

const schema = 'price';
/**
 * key base on host:port
 */
export default class PriceRequest extends BaseRequest {
  /**
	 * @returns {Promise<BaseRequest._responseHandler.props.data|undefined>}
	 */
  fetchAllLatest() {
    const url = `${schema}/all-latest`;
    return this.get(url);
  }

  /**
	 * @param {Object} params
	 * @param {string} params.coin
	 * @param {string} params.currency
	 * @returns {Promise<BaseRequest._responseHandler.props.data|undefined>}
	 */
  fetchLatest(params) {
    const url = `${schema}/latest`;
    return this.get(url, params);
  }

  /**
	 * @param {Object} params
	 * @param {string} params.coin
	 * @param {string} params.currency
	 * @returns {Promise<BaseRequest._responseHandler.props.data|undefined>}
	 */
  fetchPrice24h(params) {
    const url = `${schema}/price24h`;
    return this.get(url, params);
  }

  /**
	 * @param {Object} params
	 * @param {string} params.coin
	 * @param {string} params.currency
	 * @param {number} params.duration
	 * @returns {Promise<BaseRequest._responseHandler.props.data|undefined>}
	 */
  fetchSticks(params) {
    const url = `${schema}/sticks`;
    return this.get(url, params);
  }

  fetchPriceMarket24h(params){
    const url = `${schema}/price-market-24h`;
    return this.get(url,params);
  }
}
